webpackJsonp([1],{

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(352)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1918:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(296);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9a49db2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1920);
function injectStyle (ssrContext) {
  __webpack_require__(1919)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9a49db2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1919:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1920:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1921:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Mainpage__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CardEdit__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResourceEdit__ = __webpack_require__(1948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ResourceContainer__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProjectEdit__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ProjectContainer__ = __webpack_require__(1960);








// import Settings from '@/components/Settings'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { selector: to.hash };
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/',
    name: 'mainpage',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Mainpage__["a" /* default */]
  }, {
    path: '/edit-card',
    name: 'edit-card',
    component: __WEBPACK_IMPORTED_MODULE_3__components_CardEdit__["a" /* default */]
  }, {
    path: '/resources',
    name: 'resources',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ResourceContainer__["a" /* default */]
  }, {
    path: '/edit-resource',
    name: 'edit-resource',
    component: __WEBPACK_IMPORTED_MODULE_4__components_ResourceEdit__["a" /* default */]
  }, {
    path: '/projects',
    name: 'projects',
    component: __WEBPACK_IMPORTED_MODULE_7__components_ProjectContainer__["a" /* default */]
  }, {
    path: '/edit-project',
    name: 'edit-project',
    component: __WEBPACK_IMPORTED_MODULE_6__components_ProjectEdit__["a" /* default */]
    // },
    // {
    //   path: '/settings',
    //   name: 'settings',
    //   component: Settings
  }]
}));

/***/ }),

/***/ 1923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mainpage_vue__ = __webpack_require__(297);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_296dfa7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mainpage_vue__ = __webpack_require__(1940);
function injectStyle (ssrContext) {
  __webpack_require__(1924)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mainpage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_296dfa7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mainpage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1924:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1931:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Workload_vue__ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b27d706_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Workload_vue__ = __webpack_require__(1933);
function injectStyle (ssrContext) {
  __webpack_require__(1932)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Workload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b27d706_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Workload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1932:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1933:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workload"},[_c('b-progress',{attrs:{"max":_vm.progressSize}},[_c('b-progress-bar',{attrs:{"variant":_vm.workloadVariant,"value":_vm.acceptableLoad}}),_vm._v(" "),(_vm.overload)?_c('b-progress-bar',{attrs:{"variant":"danger","value":_vm.overload,"animated":""}}):_vm._e()],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.totalWorkload)+" / "+_vm._s(_vm.totalCapacity))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1934:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardContainer_vue__ = __webpack_require__(299);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d6d4a1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardContainer_vue__ = __webpack_require__(1939);
function injectStyle (ssrContext) {
  __webpack_require__(1935)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d6d4a1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1935:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1936:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__(300);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3200ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__(1938);
function injectStyle (ssrContext) {
  __webpack_require__(1937)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3200ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1937:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1938:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card col-sm-6 text-center",style:({'--cardColor': _vm.card.color})},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"card-side card-handle ddHandle btn btn-outline-primary"},[_c('icon',{attrs:{"name":"arrows-alt","scale":"1.5"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-6 card-body vertical-align",on:{"click":function($event){return _vm.gotoEditCard()}}},[_c('div',[_vm._v(_vm._s(_vm.card.name))])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('button',{staticClass:"card-side card-edit card-workload btn btn-outline-primary",on:{"click":function($event){return _vm.switchCard()}}},[(_vm.card.out)?_c('icon',{staticClass:"card-out",attrs:{"scale":"1.5","name":"ban","color":"red"}}):_c('span',[_vm._v(_vm._s(_vm.card.workload))])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1939:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-container container"},[_c('draggable',{attrs:{"options":{animation: 150, handle: '.ddHandle'}},model:{value:(_vm.cards),callback:function ($$v) {_vm.cards=$$v},expression:"cards"}},_vm._l((_vm.cards),function(card){return _c('card',{key:card.id,attrs:{"card":card}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1940:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('header',{staticClass:"fixed-top"},[_c('workload')],1),_vm._v(" "),_c('div',{staticClass:"content"},[_c('card-container')],1),_vm._v(" "),_c('footer',{staticClass:"fixed-bottom"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[_c('router-link',{staticClass:"btn btn-primary btn-main btn-main-resources",attrs:{"to":{ name: 'resources' }}},[_c('icon',{attrs:{"name":"users","scale":"2"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('router-link',{staticClass:"main-project vertical-align",attrs:{"to":{ name: 'projects' }}},[_vm._v("\n          "+_vm._s(_vm.currentProject.name)+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('button',{staticClass:"btn btn-dark btn-main btn-main-order",on:{"click":function($event){return _vm.orderCardsSwitch()}}},[(_vm.currentProject.order == 'alpha')?_c('icon',{attrs:{"name":"sort-alpha-down","scale":"2"}}):_vm._e(),_vm._v(" "),(_vm.currentProject.order == 'workload')?_c('icon',{attrs:{"name":"sort-numeric-down-alt","scale":"2"}}):_vm._e(),_vm._v(" "),(_vm.currentProject.order == 'color')?_c('icon',{attrs:{"name":"sort-amount-down-alt","scale":"2"}}):_vm._e(),_vm._v(" "),(_vm.currentProject.order == 0)?_c('icon',{attrs:{"name":"sort","scale":"2"}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('router-link',{staticClass:"btn btn-primary btn-main btn-main-add",attrs:{"to":{ name: 'edit-card' }}},[_c('icon',{attrs:{"name":"plus","scale":"2"}})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1941:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardEdit_vue__ = __webpack_require__(301);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208ee3bb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardEdit_vue__ = __webpack_require__(1947);
function injectStyle (ssrContext) {
  __webpack_require__(1942)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208ee3bb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1942:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardColorPick_vue__ = __webpack_require__(302);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bac45b7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardColorPick_vue__ = __webpack_require__(1946);
function injectStyle (ssrContext) {
  __webpack_require__(1945)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardColorPick_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bac45b7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardColorPick_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1945:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row color-pick-container text-center"},_vm._l((_vm.cardColors),function(color){return _c('div',{staticClass:"col-3"},[_c('div',{staticClass:"color-pick btn btn-default",style:({'--cardColor': color}),on:{"click":function($event){return _vm.pickColor(color)}}},[(_vm.current === color)?_c('icon',{attrs:{"name":"check"}}):_vm._e()],1)])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1947:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-card container-fluid"},[(_vm.card.id)?_c('h2',[_vm._v("Edit card")]):_c('h2',[_vm._v("Create card")]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"control-label col-4 col-md-2",attrs:{"for":"newName"}},[_vm._v("Name:")]),_vm._v(" "),_c('div',{staticClass:"input-group col-8 col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.card.name),expression:"card.name"}],ref:"inputCardName",staticClass:"form-control",attrs:{"type":"text","id":"newName","maxlength":"22"},domProps:{"value":(_vm.card.name)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirmEdit()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.card, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"control-label col-4 col-md-2",attrs:{"for":"newWorkload"}},[_vm._v("Workload:")]),_vm._v(" "),_c('div',{staticClass:"input-group col-8 col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.card.workload),expression:"card.workload"}],staticClass:"form-control",attrs:{"type":"number","id":"newWorkload"},domProps:{"value":(_vm.card.workload)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirmEdit()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.card, "workload", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('card-color-pick',{attrs:{"current":_vm.card.color},on:{"pick-color":_vm.pickColor}})],1),_vm._v(" "),(_vm.card.id)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.remove()}}},[_c('icon',{attrs:{"name":"trash"}}),_vm._v(" Remove")],1):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.cancelEdit()}}},[_c('icon',{attrs:{"name":"times"}}),_vm._v(" Cancel")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.confirmEdit()}}},[_c('icon',{attrs:{"name":"check"}}),_vm._v(" Save")],1),_vm._v(" "),(_vm.card.id)?_c('div',{staticClass:"project-move container-fluid"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"control-label col-4 col-md-2",attrs:{"for":"newProject"}},[_vm._v("Move to project:")]),_vm._v(" "),_c('div',{staticClass:"input-group col-8 col-md-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newProject),expression:"newProject"}],staticClass:"form-control",attrs:{"id":"newProject"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.newProject=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.changeProject()}]}},_vm._l((_vm.projects),function(project){return _c('option',{domProps:{"value":project}},[_vm._v(_vm._s(project.name))])}),0)])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1948:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceEdit_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77c53b7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceEdit_vue__ = __webpack_require__(1950);
function injectStyle (ssrContext) {
  __webpack_require__(1949)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77c53b7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1949:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1950:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-resource container-fluid"},[(_vm.resource.id)?_c('h2',[_vm._v("Edit resource")]):_c('h2',[_vm._v("Create resource")]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"control-label col-4 col-md-2",attrs:{"for":"newName"}},[_vm._v("Name:")]),_vm._v(" "),_c('div',{staticClass:"input-group col-8 col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.resource.name),expression:"resource.name"}],ref:"inputResourceName",staticClass:"form-control",attrs:{"type":"text","id":"newName","maxlength":"30"},domProps:{"value":(_vm.resource.name)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirmEdit()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.resource, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"control-label col-4 col-md-2",attrs:{"for":"newCapacity"}},[_vm._v("Capacity:")]),_vm._v(" "),_c('div',{staticClass:"input-group col-8 col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.resource.capacity),expression:"resource.capacity"}],staticClass:"form-control",attrs:{"type":"number","id":"newCapacity"},domProps:{"value":(_vm.resource.capacity)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirmEdit()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.resource, "capacity", $event.target.value)}}})])]),_vm._v(" "),(_vm.resource.id)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.remove()}}},[_c('icon',{attrs:{"name":"trash"}}),_vm._v(" Remove")],1):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.cancelEdit()}}},[_c('icon',{attrs:{"name":"times"}}),_vm._v(" Cancel")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.confirmEdit()}}},[_c('icon',{attrs:{"name":"check"}}),_vm._v(" Save")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1951:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceContainer_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c54f18ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceContainer_vue__ = __webpack_require__(1956);
function injectStyle (ssrContext) {
  __webpack_require__(1952)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c54f18ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1952:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1953:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resource_vue__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04062a07_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resource_vue__ = __webpack_require__(1955);
function injectStyle (ssrContext) {
  __webpack_require__(1954)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Resource_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04062a07_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Resource_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1954:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1955:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resource col-sm-6"},[_c('div',{staticClass:"row vertical-align"},[_c('div',{staticClass:"col-8"},[_vm._v("\n            "+_vm._s(_vm.resource.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_vm._v("\n            "+_vm._s(_vm.resource.capacity)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":{ name: 'edit-resource', params: {resource: _vm.resource} }}},[_c('icon',{attrs:{"name":"pencil-alt"}})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1956:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"resource-container"},_vm._l((_vm.resources),function(resource){return _c('resource',{key:resource.id,attrs:{"resource":resource}})}),1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('button',{staticClass:"btn btn-info",on:{"click":function($event){return _vm.back()}}},[_c('icon',{attrs:{"name":"arrow-left"}}),_vm._v(" Back")],1)]),_vm._v(" "),_c('div',{staticClass:"col-4"}),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":{ name: 'edit-resource' }}},[_c('icon',{attrs:{"name":"plus"}})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1957:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectEdit_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97e7b690_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectEdit_vue__ = __webpack_require__(1959);
function injectStyle (ssrContext) {
  __webpack_require__(1958)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97e7b690_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1958:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1959:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-project container-fluid"},[(_vm.project.id)?_c('h2',[_vm._v("Edit project")]):_c('h2',[_vm._v("Create project")]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"control-label col-4 col-md-2",attrs:{"for":"newName"}},[_vm._v("Name:")]),_vm._v(" "),_c('div',{staticClass:"input-group col-8 col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.name),expression:"project.name"}],ref:"inputProjectName",staticClass:"form-control",attrs:{"type":"text","id":"newName","maxlength":"18"},domProps:{"value":(_vm.project.name)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirmEdit()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "name", $event.target.value)}}})])]),_vm._v(" "),(_vm.project.id > 1)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.remove()}}},[_c('icon',{attrs:{"name":"trash"}}),_vm._v(" Remove")],1):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.cancelEdit()}}},[_c('icon',{attrs:{"name":"times"}}),_vm._v(" Cancel")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.confirmEdit()}}},[_c('icon',{attrs:{"name":"check"}}),_vm._v(" Save")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1960:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectContainer_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0de37ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectContainer_vue__ = __webpack_require__(1965);
function injectStyle (ssrContext) {
  __webpack_require__(1961)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0de37ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1961:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1962:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a484d20a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__ = __webpack_require__(1964);
function injectStyle (ssrContext) {
  __webpack_require__(1963)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a484d20a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1963:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1964:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project col-sm-6"},[_c('div',{staticClass:"row vertical-align"},[_c('div',{staticClass:"col-7"},[_vm._v("\n            "+_vm._s(_vm.project.name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-3"},[(_vm.isCurrent)?_c('span',[_vm._v("Current")]):_c('button',{staticClass:"btn btn-outline-success",on:{"click":function($event){return _vm.selectProject()}}},[_c('icon',{attrs:{"name":"arrow-alt-circle-left"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":{ name: 'edit-project', params: {project: _vm.project} }}},[_c('icon',{attrs:{"name":"pencil-alt"}})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1965:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"project-container"},_vm._l((_vm.projects),function(project){return _c('project',{key:project.id,attrs:{"project":project}})}),1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('button',{staticClass:"btn btn-info",on:{"click":function($event){return _vm.back()}}},[_c('icon',{attrs:{"name":"arrow-left"}}),_vm._v(" Back")],1)]),_vm._v(" "),_c('div',{staticClass:"col-4"}),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":{ name: 'edit-project' }}},[_c('icon',{attrs:{"name":"plus"}})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1966:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_vuex_dist_logger__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__node_modules_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(1968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__ = __webpack_require__(1969);



var _mutations;







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var debug = "production" !== 'production';

var persistOptions = {
  key: 'keiwen-wmp'
};

var _cardColors = ['#FFFFFF', '#F3958D', '#FCCE48', '#FFF79A', '#D9FFAE', '#BFFFF0', '#CFF1F8', '#CBDDFB', '#E5CBFC', '#FDE0F0', '#EFDCC7', '#EAEBEE'];

var defaultCard = {
  id: 0,
  name: '',
  color: _cardColors[0],
  workload: 0,
  out: false
};

var defaultResource = {
  id: 0,
  name: '',
  capacity: 0
};

var defaultProject = {
  id: 0,
  name: '',
  nextCardId: 1,
  lastCardChanged: 0,
  cards: [],
  nextResourceId: 1,
  lastResourceChanged: 0,
  order: 0,
  resources: []
};

var firstProject = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(defaultProject));
firstProject.id = 1;
firstProject.name = 'Project';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    nextProjectId: 2,
    lastProjectChanged: 0,
    currentProjectId: 1,
    projects: [JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(firstProject))]
  },
  getters: {
    projects: function projects(state) {
      return state.projects;
    },
    getDefaultProject: function getDefaultProject(state) {
      return function () {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(defaultProject));
      };
    },
    getProjectIndex: function getProjectIndex(state) {
      return function (projectId) {
        if (typeof projectId === 'undefined') projectId = state.currentProjectId;
        for (var i = 0; i < state.projects.length; i++) {
          var project = state.projects[i];
          if (project.id === projectId) {
            return i;
          }
        }
        return -1;
      };
    },
    getProject: function getProject(state, getters) {
      return function (projectId) {
        if (typeof projectId === 'undefined') projectId = state.currentProjectId;
        var projectIndex = getters.getProjectIndex(projectId);
        if (projectIndex < 0) return {};
        return state.projects[projectIndex];
      };
    },
    currentProject: function currentProject(state, getters) {
      return getters.getProject();
    },
    cards: function cards(state, getters) {
      return getters.currentProject.cards;
    },
    getDefaultCard: function getDefaultCard(state) {
      return function () {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(defaultCard));
      };
    },
    getCardIndex: function getCardIndex(state, getters) {
      return function (cardId, projectId) {
        if (typeof projectId === 'undefined') projectId = state.currentProjectId;
        var project = getters.getProject(projectId);
        if (typeof project.id === 'undefined') return -1;
        for (var i = 0; i < project.cards.length; i++) {
          var card = project.cards[i];
          if (card.id === cardId) {
            return i;
          }
        }
        return -1;
      };
    },
    getCard: function getCard(state, getters) {
      return function (cardId, projectId) {
        if (typeof projectId === 'undefined') projectId = state.currentProjectId;
        var cardIndex = getters.getCardIndex(cardId, projectId);
        if (cardIndex < 0) return {};
        var project = getters.getProject(projectId);
        return project.cards[cardIndex];
      };
    },
    cardColors: function cardColors(state) {
      return _cardColors;
    },
    resources: function resources(state, getters) {
      return getters.currentProject.resources;
    },
    getDefaultResource: function getDefaultResource(state) {
      return function () {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(defaultResource));
      };
    },
    getResourceIndex: function getResourceIndex(state, getters) {
      return function (resourceId, projectId) {
        if (typeof projectId === 'undefined') projectId = state.currentProjectId;
        var project = getters.getProject(projectId);
        if (typeof project.id === 'undefined') return -1;
        for (var i = 0; i < project.resources.length; i++) {
          var resource = project.resources[i];
          if (resource.id === resourceId) {
            return i;
          }
        }
        return -1;
      };
    },
    getResource: function getResource(state, getters) {
      return function (resourceId, projectId) {
        if (typeof projectId === 'undefined') projectId = state.currentProjectId;
        var resourceIndex = getters.getResourceIndex(resourceId, projectId);
        if (resourceIndex < 0) return {};
        var project = getters.getProject(projectId);
        return project.resources[resourceIndex];
      };
    }
  },
  actions: {
    setCard: function setCard(_ref, cardData) {
      var getters = _ref.getters,
          commit = _ref.commit;

      // be sure to have id
      if (cardData.id === undefined) cardData.id = 0;
      var projectIndex = getters.getProjectIndex();
      if (projectIndex < 0) return;
      var cardIndex = getters.getCardIndex(cardData.id);
      // be sure to have int in workload
      cardData.workload = parseInt(cardData.workload);

      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* SET_CARD */], { cardData: cardData, cardIndex: cardIndex, projectIndex: projectIndex });
    },
    switchCardInOut: function switchCardInOut(_ref2, cardId) {
      var getters = _ref2.getters,
          commit = _ref2.commit;

      var projectIndex = getters.getProjectIndex();
      if (projectIndex < 0) return;
      var cardIndex = getters.getCardIndex(cardId);

      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* SWITCH_CARD */], { cardId: cardId, cardIndex: cardIndex, projectIndex: projectIndex });
    },
    removeCard: function removeCard(_ref3, cardId) {
      var getters = _ref3.getters,
          commit = _ref3.commit;

      var projectIndex = getters.getProjectIndex();
      if (projectIndex < 0) return;
      var cardIndex = getters.getCardIndex(cardId);

      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* REMOVE_CARD */], { cardIndex: cardIndex, projectIndex: projectIndex });
    },
    reorderCard: function reorderCard(_ref4, cards) {
      var getters = _ref4.getters,
          commit = _ref4.commit;

      var projectIndex = getters.getProjectIndex();
      if (projectIndex < 0) return;

      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* CHANGE_CARDS */], { cards: cards, projectIndex: projectIndex, order: 0 });
    },
    orderCardsBy: function orderCardsBy(_ref5, order) {
      var getters = _ref5.getters,
          commit = _ref5.commit;

      var projectIndex = getters.getProjectIndex();
      if (projectIndex < 0) return;
      var cards = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(getters.cards));

      cards.sort(function (cardA, cardB) {
        switch (order) {
          case 'workload':
            return cardB.workload - cardA.workload;
          case 'color':
            return _cardColors.indexOf(cardA.color) - _cardColors.indexOf(cardB.color);
          default:
            order = 'alpha';
            if (cardB.name.toLowerCase() > cardA.name.toLowerCase()) return -1;
            return 1;
        }
      });
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* CHANGE_CARDS */], { cards: cards, projectIndex: projectIndex, order: order });
    },
    orderCardsSwitch: function orderCardsSwitch(_ref6) {
      var getters = _ref6.getters,
          dispatch = _ref6.dispatch;

      var currentOrder = getters.currentProject.order;
      var newOrder = 'alpha';
      switch (currentOrder) {
        case 'alpha':
          newOrder = 'workload';
          break;
        case 'workload':
          newOrder = 'color';
          break;
      }
      dispatch('orderCardsBy', newOrder);
    },
    moveCard: function moveCard(_ref7, payload) {
      var getters = _ref7.getters,
          commit = _ref7.commit;

      // be sure to have id
      if (payload.card.id === undefined) return;
      var fromProjectIndex = getters.getProjectIndex();
      var toProjectIndex = getters.getProjectIndex(payload.toProjectId);
      if (fromProjectIndex < 0 || toProjectIndex < 0) return;
      var cardIndex = getters.getCardIndex(payload.card.id);
      // be sure to have int in workload
      payload.card.workload = parseInt(payload.card.workload);

      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* SET_CARD */], { cardData: payload.card, cardIndex: -1, projectIndex: toProjectIndex });
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* REMOVE_CARD */], { cardIndex: cardIndex, projectIndex: fromProjectIndex });
    },
    setResource: function setResource(_ref8, resourceData) {
      var getters = _ref8.getters,
          commit = _ref8.commit;

      // be sure to have id
      if (resourceData.id === undefined) resourceData.id = 0;
      var projectIndex = getters.getProjectIndex();
      if (projectIndex < 0) return;
      var resourceIndex = getters.getResourceIndex(resourceData.id);
      // be sure to have int in capacity
      resourceData.capacity = parseInt(resourceData.capacity);

      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* SET_RESOURCE */], { resourceData: resourceData, resourceIndex: resourceIndex, projectIndex: projectIndex });
    },
    removeResource: function removeResource(_ref9, resourceId) {
      var getters = _ref9.getters,
          commit = _ref9.commit;

      var projectIndex = getters.getProjectIndex();
      if (projectIndex < 0) return;
      var resourceIndex = getters.getResourceIndex(resourceId);

      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* REMOVE_RESOURCE */], { resourceId: resourceId, resourceIndex: resourceIndex, projectIndex: projectIndex });
    },
    setProject: function setProject(_ref10, projectData) {
      var getters = _ref10.getters,
          commit = _ref10.commit;

      // be sure to have id
      if (projectData.id === undefined) projectData.id = 0;
      var projectIndex = getters.getProjectIndex(projectData.id);

      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* SET_PROJECT */], { projectData: projectData, projectIndex: projectIndex });
    },
    removeProject: function removeProject(_ref11, projectId) {
      var getters = _ref11.getters,
          commit = _ref11.commit;

      var projectIndex = getters.getProjectIndex(projectId);

      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* REMOVE_PROJECT */], { projectId: projectId, projectIndex: projectIndex });
    },
    pickProject: function pickProject(_ref12, projectId) {
      var getters = _ref12.getters,
          commit = _ref12.commit;

      var projectIndex = getters.getProjectIndex(projectId);
      if (projectIndex < 0) return;

      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* PICK_PROJECT */], projectId);
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* SET_CARD */], function (state, payload) {
    var project = state.projects[payload.projectIndex];
    if (payload.cardIndex >= 0) {
      // update
      project.cards[payload.cardIndex] = payload.cardData;
    } else {
      // create
      payload.cardData.id = project.nextCardId;
      project.nextCardId++;
      project.cards.push(payload.cardData);
    }
    project.order = 0;
    project.lastCardChanged = payload.cardData.id;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* SWITCH_CARD */], function (state, payload) {
    var project = state.projects[payload.projectIndex];
    project.cards[payload.cardIndex].out = !project.cards[payload.cardIndex].out;
    project.lastCardChanged = payload.cardId;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* REMOVE_CARD */], function (state, payload) {
    var project = state.projects[payload.projectIndex];
    project.cards.splice(payload.cardIndex, 1);
    project.lastCardChanged = 0;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* CHANGE_CARDS */], function (state, payload) {
    var project = state.projects[payload.projectIndex];
    project.cards = payload.cards;
    project.order = payload.order;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* SET_RESOURCE */], function (state, payload) {
    var project = state.projects[payload.projectIndex];
    if (payload.resourceIndex >= 0) {
      // update
      project.resources[payload.resourceIndex] = payload.resourceData;
    } else {
      // create
      payload.resourceData.id = project.nextResourceId;
      project.nextResourceId++;
      project.resources.push(payload.resourceData);
    }
    project.lastResourceChanged = payload.resourceData.id;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* REMOVE_RESOURCE */], function (state, payload) {
    var project = state.projects[payload.projectIndex];
    project.resources.splice(payload.resourceIndex, 1);
    project.lastResourceChanged = payload.resourceId;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* SET_PROJECT */], function (state, payload) {
    if (payload.projectIndex >= 0) {
      // update
      state.projects[payload.projectIndex].name = payload.projectData.name;
      state.lastProjectChanged = payload.projectData.id;
    } else {
      // create
      var project = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(defaultProject));
      project.name = payload.projectData.name;
      project.id = state.nextProjectId;
      state.nextProjectId++;
      state.projects.push(project);
      // new project set as current
      state.currentProjectId = project.id;
      state.lastProjectChanged = project.id;
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* REMOVE_PROJECT */], function (state, payload) {
    state.projects.splice(payload.projectIndex, 1);
    // if removed is the current one, set back the first project
    if (state.currentProjectId === payload.projectId) {
      state.currentProjectId = 1;
    }
    state.lastProjectChanged = payload.projectId;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* PICK_PROJECT */], function (state, projectId) {
    state.currentProjectId = projectId;
  }), _mutations),
  strict: debug,
  plugins: debug ? [__WEBPACK_IMPORTED_MODULE_4__node_modules_vuex_dist_logger___default()(), Object(__WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__["a" /* default */])(persistOptions)] : [Object(__WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__["a" /* default */])(persistOptions)]
}));

/***/ }),

/***/ 1968:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SWITCH_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REMOVE_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_CARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_RESOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REMOVE_RESOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PICK_PROJECT; });
/* unused harmony export MOVE_CARD */
var SET_CARD = 'SET_CARD';
var SWITCH_CARD = 'SWITCH_CARD';
var REMOVE_CARD = 'REMOVE_CARD';
var CHANGE_CARDS = 'CHANGE_CARDS';
var SET_RESOURCE = 'SET_RESOURCE';
var REMOVE_RESOURCE = 'REMOVE_RESOURCE';
var SET_PROJECT = 'SET_PROJECT';
var REMOVE_PROJECT = 'REMOVE_PROJECT';
var PICK_PROJECT = 'PICK_PROJECT';
var MOVE_CARD = 'MOVE_CARD';

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);



var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    title: String,
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String,
    tabindex: [Number, String]
  },
  data: function data() {
    return {
      id: getId(),
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    },
    focusable: function focusable() {
      var tabindex = this.tabindex;

      if (tabindex == null) {
        return 'false';
      }
      var index = typeof tabindex === 'string' ? parseInt(tabindex, 10) : tabindex;
      if (index >= 0) {
        return null;
      }
      return 'false';
    }
  },
  mounted: function mounted() {
    this.updateStack();
  },
  updated: function updated() {
    this.updateStack();
  },

  methods: {
    updateStack: function updateStack() {
      var _this = this;

      if (!this.name && this.name !== null && this.$children.length === 0) {
        console.warn('Invalid prop: prop "name" is required.');
        return;
      }

      if (this.icon) {
        return;
      }

      var width = 0;
      var height = 0;
      this.$children.forEach(function (child) {
        child.outerScale = _this.normalizedScale;

        width = Math.max(width, child.width);
        height = Math.max(height, child.height);
      });
      this.childrenWidth = width;
      this.childrenHeight = height;
      this.$children.forEach(function (child) {
        child.x = (width - child.width) / 2;
        child.y = (height - child.height) / 2;
      });
    }
  },
  render: function render(h) {
    if (this.name === null) {
      return h();
    }

    var options = {
      class: this.klass,
      style: this.style,
      attrs: {
        role: this.$attrs.role || (this.label || this.title ? 'img' : null),
        'aria-label': this.label || null,
        'aria-hidden': String(!(this.label || this.title)),
        tabindex: this.tabindex,
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        viewBox: this.box,
        focusable: this.focusable
      }
    };

    var titleId = 'vat-' + this.id;
    if (this.title) {
      options.attrs['aria-labelledby'] = titleId;
    }

    if (this.raw) {
      var html = this.raw;

      if (this.title) {
        html = '<title id="' + titleId + '">' + escapeHTML(this.title) + '</title>' + html;
      }

      options.domProps = {
        innerHTML: html
      };
    }

    var content = this.title ? [h('title', { attrs: { id: titleId } }, this.title)] : [];

    return h('svg', options, this.raw ? null : content.concat(this.$slots.default || [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.icon.paths.map(function (path, i) {
      return h('path', {
        attrs: path,
        key: 'path-' + i
      });
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.icon.polygons.map(function (polygon, i) {
      return h('polygon', {
        attrs: polygon,
        key: 'polygon-' + i
      });
    })))));
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];
      var _icon$paths = icon.paths,
          paths = _icon$paths === undefined ? [] : _icon$paths,
          d = icon.d,
          _icon$polygons = icon.polygons,
          polygons = _icon$polygons === undefined ? [] : _icon$polygons,
          points = icon.points;


      if (d) {
        paths.push({ d: d });
      }

      if (points) {
        polygons.push({ points: points });
      }

      icons[name] = assign({}, icon, {
        paths: paths,
        polygons: polygons
      });
    }
  },

  icons: icons
});

function assign(obj) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  sources.forEach(function (source) {
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        obj[key] = source[key];
      }
    }
  });

  return obj;
}

var cursor = 0xd4937;
function getId() {
  return 'va-' + (cursor++).toString(16);
}

var ESCAPE_MAP = {
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '&': '&amp;'
};

function escapeHTML(html) {
  return html.replace(/[<>"&]/g, function (c) {
    return ESCAPE_MAP[c] || c;
  });
}

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Workload__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CardContainer__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mainpage',
  components: { Workload: __WEBPACK_IMPORTED_MODULE_1__Workload__["a" /* default */], CardContainer: __WEBPACK_IMPORTED_MODULE_2__CardContainer__["a" /* default */] },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['currentProject'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['orderCardsSwitch']))
});

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'workload',
  components: {},
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['resources', 'cards']), {
    totalCapacity: function totalCapacity() {
      return this.resources.reduce(function (total, resource) {
        return total + resource.capacity;
      }, 0);
    },
    totalWorkload: function totalWorkload() {
      return this.cards.reduce(function (total, card) {
        if (card.out) {
          return total;
        }
        return total + card.workload;
      }, 0);
    },
    progressSize: function progressSize() {
      return Math.max(this.totalCapacity, this.totalWorkload);
    },
    overload: function overload() {
      if (this.totalWorkload > this.totalCapacity) return this.totalWorkload - this.totalCapacity;
      return 0;
    },
    acceptableLoad: function acceptableLoad() {
      if (this.overload) return this.totalCapacity;
      return this.totalWorkload;
    },
    workloadVariant: function workloadVariant() {
      return 'primary';
    }
  })
});

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(1936);

//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card-container',
  components: { Card: __WEBPACK_IMPORTED_MODULE_2__Card__["a" /* default */] },
  data: function data() {
    return {};
  },

  computed: {
    cards: {
      get: function get() {
        return this.$store.getters.currentProject.cards;
      },
      set: function set(reorderedCards) {
        this.reorderCard(reorderedCards);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['reorderCard']))
});

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card',
  props: ['card'],
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['switchCardInOut']), {
    gotoEditCard: function gotoEditCard() {
      this.$router.push({ name: 'edit-card', params: { card: this.card } });
    },
    switchCard: function switchCard() {
      this.switchCardInOut(this.card.id);
    }
  })
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardColorPick__ = __webpack_require__(1944);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card-edit',
  components: { CardColorPick: __WEBPACK_IMPORTED_MODULE_3__CardColorPick__["a" /* default */] },
  data: function data() {
    return {
      card: {},
      newProject: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getDefaultCard', 'cardColors', 'currentProject', 'projects'])),
  mounted: function mounted() {
    this.card = this.$route.params.card;
    if (!this.card) this.card = this.getDefaultCard();
    this.card = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.card));
    this.newProject = this.currentProject;
    if (!this.card.id) {
      // no focus on update, it will open keyboard and hide bottom screen
      this.$refs.inputCardName.focus();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setCard', 'removeCard', 'moveCard']), {
    confirmEdit: function confirmEdit() {
      this.setCard(this.card);
      this.$router.push({ name: 'mainpage' });
    },
    cancelEdit: function cancelEdit() {
      this.$router.push({ name: 'mainpage' });
    },
    remove: function remove() {
      this.removeCard(this.card.id);
      this.$router.push({ name: 'mainpage' });
    },
    pickColor: function pickColor(pick) {
      this.card.color = pick;
    },
    changeProject: function changeProject() {
      this.moveCard({ toProjectId: this.newProject.id, card: this.card });
      this.$router.push({ name: 'mainpage' });
    }
  })
});

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'card-color-pick',
  props: ['current'],
  data: function data() {
    return {
      pick: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['cardColors'])),
  methods: {
    pickColor: function pickColor(key) {
      this.pick = key;
      this.$emit('pick-color', key);
    }
  }
});

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'resource-edit',
  components: {},
  data: function data() {
    return {
      resource: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getDefaultResource'])),
  mounted: function mounted() {
    this.resource = this.$route.params.resource;
    if (!this.resource) this.resource = this.getDefaultResource();
    this.resource = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.resource));
    this.$refs.inputResourceName.focus();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setResource', 'removeResource']), {
    confirmEdit: function confirmEdit() {
      this.setResource(this.resource);
      this.$router.push({ name: 'resources' });
    },
    cancelEdit: function cancelEdit() {
      this.$router.push({ name: 'resources' });
    },
    remove: function remove() {
      this.removeResource(this.resource.id);
      this.$router.push({ name: 'resources' });
    }
  })
});

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Resource__ = __webpack_require__(1953);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'resource-container',
  components: { Resource: __WEBPACK_IMPORTED_MODULE_2__Resource__["a" /* default */] },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['resources'])),
  methods: {
    back: function back() {
      this.$router.push({ name: 'mainpage' });
    }
  }
});

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'resource',
  props: ['resource'],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project-edit',
  components: {},
  data: function data() {
    return {
      project: {
        id: 0,
        name: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getDefaultProject'])),
  mounted: function mounted() {
    if (this.$route.params.project) {
      this.project.id = this.$route.params.project.id;
      this.project.name = this.$route.params.project.name;
    }
    this.$refs.inputProjectName.focus();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setProject', 'removeProject']), {
    confirmEdit: function confirmEdit() {
      this.setProject(this.project);
      this.$router.push({ name: 'projects' });
    },
    cancelEdit: function cancelEdit() {
      this.$router.push({ name: 'projects' });
    },
    remove: function remove() {
      this.removeProject(this.project.id);
      this.$router.push({ name: 'projects' });
    }
  })
});

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Project__ = __webpack_require__(1962);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project-container',
  components: { Project: __WEBPACK_IMPORTED_MODULE_2__Project__["a" /* default */] },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['projects'])),
  methods: {
    back: function back() {
      this.$router.push({ name: 'mainpage' });
    }
  }
});

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project',
  props: ['project'],
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['currentProject']), {
    isCurrent: function isCurrent() {
      return this.currentProject.id === this.project.id;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['pickProject']), {
    selectProject: function selectProject() {
      this.pickProject(this.project.id);
      this.$router.push({ name: 'mainpage' });
    }
  })
});

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(1966);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('draggable', __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */] }
});

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 352:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[309]);


// WEBPACK FOOTER //
// static/js/app.850acc4ec252d2b901f0.js